import post from './post.js';

export default {
	login: ({ login, password }) => post('user/sign_in', { login, password }),
	resume_session: (session) => post('user/resume_session', { session }),
};
